import React, { useEffect } from "react";
import { get_dashboard } from "../../services/DashboardService";
import { Table, Spin } from "antd";
// import {
//   IconTrendIncreasePictogram,
//   IconTrendDecreasePictogram,
// } from "@ttd/icons";



import {
  CaretUpFilled,
  CaretDownFilled
} from "@ant-design/icons";

import { useAuth } from "react-oidc-context";

import { get_outcomes_user_group } from "../../services/SessionTools";

function percentageFormatter(num) {
  return new Intl.NumberFormat("default", {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);
}

function Dashboard() {
  const [dashboardData, setDashboardData] = React.useState([]);
  const [dashboardLoaded, setDashboardLoaded] = React.useState(false);
  const auth = useAuth();

  useEffect(() => {
    if (dashboardLoaded === false) {
      console.log("useEffect: loading dashbaord");
      get_dashboard(auth.user.id_token)
        .then((res) => {
          let results = res;
          console.log("results: ", results);
          setTimeout(() => {
            setDashboardData(results);
            setDashboardLoaded(true);
          }, 200);
        })
        .catch(function (error) {
          console.log("Something went wrong loading dashboard!");
          console.log(error);
          setDashboardLoaded(true);
        });
    } else {
    }
  }, [dashboardLoaded, auth.user.id_token]);

  let user_group = get_outcomes_user_group(auth.user);

  return (
    <div>
      <h2>Outcome Pacing Dashboard</h2>
      {user_group !== null ? <h3>{user_group.Display}</h3> : <h3>&nbsp;</h3>}
      {dashboardLoaded === false && (
        <div className="loader_overlay">
          <Spin fullscreen />
        </div>
      )}
      {dashboardLoaded && (
        <Table
          columns={[
            {
              dataIndex: "advertiser_id",
              title: "Advertiser Id",
              sorter: (a, b) => a.advertiser_id.localeCompare(b.advertiser_id),
            },

            {
              dataIndex: "campaign_id",
              title: "Campaign Id",
              sorter: (a, b) => a.campaign_id.localeCompare(b.campaign_id),
            },

            {
              dataIndex: "campaign_name",
              title: "Campaign",
              sorter: (a, b) => a.campaign_name.localeCompare(b.campaign_name),
              render: (value, record, index) => (
                <a target="_blank" rel="noreferrer" href={record.ui_camp_link}>
                  {value}
                </a>
              ),
            },
            {
              dataIndex: "start",
              sorter: (a, b) => new Date(a.start) - new Date(b.start),
              title: "Campaign Flight Start Date",
            },

            {
              dataIndex: "end",
              sorter: (a, b) => new Date(a.end) - new Date(b.end),
              title: "Campaign Flight End Date",
            },

            {
              dataIndex: "outcome_budget",
              title: "Outcome Budget",
              sorter: (a, b) => a.outcome_budget - b.outcome_budget,
              render: (value, record, index) => value,
            },
            {
              dataIndex: "outcome_generated",
              title: "Outcome Generated",
              sorter: (a, b) => a.outcome_generated - b.outcome_generated,
              render: (value, record, index) => value,
            },

            {
              title: "Extra Budget Needed",
              dataIndex: ['extra_budget_needed', 'currency_sign'],
              sorter: (a, b) => a.extra_budget_needed - b.extra_budget_needed,
              render: (text, row) => (
                <span>{row["currency_sign"]}&nbsp;{row['extra_budget_needed']}</span>),
            },

            {
              dataIndex: "pacing",
              title: "Pacing",
              sorter: (a, b) => a.pacing - b.pacing,
              render: (value, record, index) =>
                value > 0.9 ? (
                  <div style={{ display: "flex" }}>
                    <span>{percentageFormatter(value)}&nbsp;</span>
                    <CaretUpFilled  style={{color: "green"}} />
                  </div>
                ) : (
                  <div style={{ display: "flex" }}>
                    <span>{percentageFormatter(value)}&nbsp;</span>
                    <CaretDownFilled  style={{color: "#E52900"}}/>
                  </div>
                ),
            },
          ]}
          data-ttd-inspect-id="campaign_list_table"
          dataSource={dashboardData}
          rowKey="campaign_id"
          rowStyle={{
            height: "standard",
          }}
          pagination={{
            pageSizeOptions: [5, 25, 50, 100],
            pageSize: 100,
          }}
        />
      )}
    </div>
  );
}

export default Dashboard;
